(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ShortcutAddLink',
	};
	
	$(document).ready(function documentReady()
	{	
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.add-shortcut').click(function showAddLink(e) {

			e.preventDefault();

			$('.add-shortcut').addClass('hidden');

			$('.search-link').animate({width: '350px'}, 500, function animateAddLink() {
				$(this).css(
					{
						overflow: 'visible'
					}
				);
			});
		});

		$('.hide-add-link').click(function hideAddLink(e) {

			e.preventDefault();

			$('.add-shortcut').removeClass('hidden');

			$('.search-link').animate({width: '0'}, 500, function animateCloseLink() {
				$(this).css(
					{
						overflow: 'hidden'
					}
				);
				$('.shortcut-search-autocomplete').val('');
			});
		});

		Adzuki.Typeahead(
			'.shortcut-search-autocomplete',
			function search(term, display, $self)
			{
				var _request = Adzuki.Ajax.get('/Shortcuts/autocomplete/' + term);
				_request.then(function searchResults(response)
				{
					display(response);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for shortcut."}]);
				});
			},
			function select(item, $self) {
				if (item.id !== null) {

					Adzuki.Ajax.post(
						'/Shortcuts/saveBookmark/', 
							{
								id: item.id
							}
					)
					.then(function searchResults(response)
					{
						if (response.success) {
							$self.removeClass('ajax-spinner');
							_loadShortCutList(response.total);
						} else {
							$self.removeClass('ajax-spinner');
							$('.shortcut-search-autocomplete').val('');
							Adzuki.StatusMessage('Error', response.message);
							_hideSearchLink();
						}
					})
					.catch(function searchError()
					{
						Adzuki.StatusMessage('Error', 'Unable to save shortcut.');
					});
				}
			},
			function template(item) {
				return JSON.stringify(item);
			}
		);
	};

	function _loadShortCutList(count)
	{
		console.log('total: ' + count);
		Adzuki.Ajax.get('/Shortcuts/topView')
			.then(function populateShortcuts(response) {
				$('.shortcuts-container').html(response);
				$('.shortcut-search-autocomplete').val('');
				Adzuki.StatusMessage('Success', 'You have added ' + count + ' of 20 shortcuts');
			}
		);
	}

	function _hideSearchLink()
	{
		$('.add-shortcut').removeClass('hidden');

		$('.search-link').animate({width: '0'}, 500, function animateCloseLink() {
			$(this).css(
				{
					overflow: 'hidden'
				}
			);
			$('.shortcut-search-autocomplete').val('');
		});
	}

}(jQuery, window.Adzuki || {}));